import React from "react";

export default function RandomButton() {
  return (
    <div className="px-10 py-3 bg-slate-300 text-slate-800 hover:bg-slate-800 hover:text-slate-300 rounded-md text-2xl">
      Random
    </div>
  );
}
